import { useEffect, useRef, useState } from 'react';
import { Navigation } from 'lucide-react';
import { JOB_STEP } from '@nu/shared';
import { directionsUrl } from './format.js';
import { markJob } from './progress.js';

// Directions to a job. On a job that hasn't started, a small pop-up first
// says where it's going and that the job will be marked On route; once on
// route (or later) it just opens the map.
export default function Directions({ job, className = 'btn', label, iconOnly = false }) {
  const [asking, setAsking] = useState(false);
  const content = <><Navigation size={iconOnly ? 14 : 18} aria-hidden="true" />{!iconOnly && ` ${label || 'Directions'}`}</>;
  const aria = iconOnly ? `Directions to ${job.postcode}` : undefined;

  if (JOB_STEP[job.status] !== 0) {
    return <a className={className} href={directionsUrl(job)} target="_blank" rel="noreferrer" aria-label={aria}>{content}</a>;
  }
  return (
    <>
      <button type="button" className={className} aria-label={aria} onClick={() => setAsking(true)}>{content}</button>
      {asking && <OnRoutePopup job={job} onClose={() => setAsking(false)} />}
    </>
  );
}

function OnRoutePopup({ job, onClose }) {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const address = [job.addressLine1, job.town, job.postcode].filter(Boolean).join(', ');
  return (
    <div className="popup-backdrop" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="popup" role="dialog" aria-modal="true" aria-labelledby="onroute-title" tabIndex={-1} ref={ref}>
        <p className="popup-kicker">Directions to</p>
        <h2 id="onroute-title" className="popup-title">{address}</h2>
        <p className="popup-note">{job.reference} will be marked <strong>On route</strong>.</p>
        <a
          className="btn primary popup-btn"
          href={directionsUrl(job)}
          target="_blank"
          rel="noreferrer"
          onClick={() => { markJob(job, 'on_the_way'); onClose(); }}
        >
          <Navigation size={18} aria-hidden="true" /> Open Maps and mark On route
        </a>
        <button type="button" className="btn popup-btn popup-cancel" onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
}
